<template>
  <v-dialog 
    v-model="activeMode"  
    max-width="800"
    @click:outside="closeForm()"
    :fullscreen="$vuetify.breakpoint.smAndDown"
  >
    <v-card>
      <v-toolbar
        color="primary"
        dark
        flat
      >
        <v-toolbar-title>Тексты по городам</v-toolbar-title>
        <v-spacer></v-spacer>

        <v-btn icon @click="closeForm()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      
      <v-card-text class="mt-2 pt-2">
        <div class="d-flex pa-2">
          <v-spacer></v-spacer>
          <v-btn 
            color="primary" 
            dark 
            @click="generate()"
          > 
            <v-icon left>mdi-lightbulb-on</v-icon>
            Сгенерировать тексты
          </v-btn>
          <v-spacer></v-spacer>
        </div>
        
        <v-textarea
          v-for="key of Object.keys(obj)"
          :label="key"
          v-model="obj[key]"
          :key="key"
          class="mt-2"
          filled
        ></v-textarea>
      </v-card-text>

      <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeForm()">Закрыть</v-btn>
          <v-btn 
            color="blue darken-1" 
            text 
            @click="save"
          >Сохранить</v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import _ from 'lodash';
import { mapState, mapGetters } from 'vuex';
import txtutils from '../../../models/textutils';

export default {
  name: 'site-page-text-cities',
  props: {
    value: Object,
    activeMode: Boolean,
    template: String
  },
  data() {
    //alert(this.value);
    return {
      obj: Boolean(this.value) ? _.cloneDeep(this.value) : this.getDefaultObj()
    }
  },
  methods: {
    getDefaultObj() {
      //alert(this.$store.state.sites.cities);
      let obj = {};
      for (let city of this.$store.state.sites.cities) obj[city] = '';
      //alert(obj);
      return obj;
    },
    save() {
      this.$emit('input', this.obj);
      this.$nextTick(() => this.closeForm());
    },
    closeForm() {
      this.obj = this.value ? _.cloneDeep(this.value) : this.getDefaultObj();
      this.$emit('closeForm');
    },
    generate() {
      // Генерация текстов по шаблону
      let graph = txtutils.generateTextGraph(this.template);

      let wantedResults = 62;
      let results = new Set();
      let iters = 0;
      while (wantedResults != 0) {
        let v = txtutils.generateRand(graph, true);
        if (!results.has(v)) {
          results.add(v);
          wantedResults--;
        }
        iters++;
        if (iters > 1000) {
          this.$store.dispatch('showMessage', 'Шаблон слишком простой.');
          break;
        }
      }
      let texts = Array.from(results);
      //console.log(texts);
      for (let key of Object.keys(this.obj)) {
        if (texts.length > 0) {
          this.obj[key] = texts[0];
          texts.splice(0, 1);
        }
      }
    },
  },
  computed: {
    ...mapState('sites', ['cities']),
  }
}
</script>